<template>
  <div class="dialogues">
    <div class="condition">
      <div class="title" style="padding-bottom:16px;margin-bottom:24px;height:40px;border-bottom:1px solid rgba(240, 240, 240, 1)">
        <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold" class="left">资源包列表</span>
        <a-icon class="right" @click="ifDisplay" v-if='ifShowPackage' type="up" />
        <a-icon class="right" @click="ifDisplay" v-if='!ifShowPackage' type="down" />
      </div>
      <div style="clear:both"></div>
      <div v-if='ifShowPackage'>
        <a-row>
          <a-col :span="5">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">名称查询：</div>
            <a-input class="phone" style="min-width:195px;width:100%;max-width:220px;" v-model="inputName" placeholder="请输入" />
          </a-col>
          <a-col :span="6">
            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">类型：</div>
            <a-select style="min-width:270px;width:100%;max-width:280px;" v-model="selectType" placeholder='请选择'>
              <a-select-option value="2">
                按次
              </a-select-option>
              <a-select-option value="3">
                按天
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="8">
            <div class="title" style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">到期时间：</div>
            <a-range-picker  v-model="dateList" :locale="locale" style="" format="YYYY-MM-DD HH:mm:ss" />
          </a-col>
          <a-col :span="5" style="padding-top:29px;">
            <a-button @click="reset" style="margin-right:13px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);width:80px;text-align:center">重置</a-button>
            <a-button type="primary" @click="queryDataSource()" style="border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1);width:80px;text-align:center">查询</a-button>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="result-view">
      <div class="operation">
        <div class="left" style="display:inline-block">
          <span style="color:rgba(51, 51, 51, 1);font-size:16px;">查询结果：</span>
          <span style="color:rgba(34, 215, 187, 1)">{{totalSource}}</span>
        </div>
        <div class="right">
        <a-button @click="goToMiddleCenter" type="primary" style="margin-right:8px;background:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1)">去购买</a-button>
        </div>
      </div>
      <div style="clear:both"></div>
      <div class="table-content">
        <a-table :data-source="packageSourceData" :pagination='false' :loading="ifShowLoadingSource" :rowKey="record => record.id">
          <a-table-column key="orderId" title="订单id" data-index="orderId" />
          <a-table-column key="name" title="资源包名称" data-index="name" />
          <a-table-column key="type" title="类型" data-index="type" />
          <a-table-column key="unit" title="单位" data-index="unit" />
          <a-table-column key="total" title="总量" data-index="total" />
          <a-table-column key="surplus" title="余量" data-index="surplus" />
          <a-table-column key="startTime" title="生效时间" data-index="startTime" />
          <a-table-column key="endTime" title="到期时间" data-index="endTime" />
          <a-table-column key="status" title="状态" data-index="status">
            <template slot-scope="text, record">
              <span v-if="record.status==1">有效</span>
              <span v-if="record.status==2">已停用</span>
            </template>
          </a-table-column>
        </a-table>
        <a-pagination
          style="float:right;margin-top:16px"
          v-model="currentPageSource"
          :page-size-options="pageSizeOptionsSource"
          :total="totalSource"
          show-size-changer
          :page-size="pageSizeSource"
          @showSizeChange="onShowSizeChangeSource"
          @change="onChangeSampleSource"
        >
          <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
          </template>
        </a-pagination>
      </div>
    </div>
    <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
      <a-icon style="z-index:1000;font-size:25px" type="message" />
    </router-link> -->
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
export default {
  name: 'Dialogues',
  props: {
    msg: String
  },
  data() {
    return {
      locale,
      ifShowPackage:true,
      inputName: '',
      selectType: undefined,
      dateList: [],
      currentPageSource: 1,
      packageSourceData: [],
      totalSource: 0,
      ifShowLoadingSource: false,
      pageSizeSource: 10,
      pageSizeOptionsSource: ['10', '20', '50', '100'],
    }
  },
  methods: {
    moment,
    ifDisplay(){
      this.ifShowPackage = !this.ifShowPackage
    },
    onShowSizeChangeSource(current, pageSize) {
      this.currentPageSource = current
      this.pageSizeSource = pageSize;
    },
    onChangeSampleSource(current, pageSize) {
      this.currentPageSource = current
      this.pageSizeSource = pageSize
    },
    queryDataSource() {
      this.ifShowLoadingSource = true
      this.axios(
        {
          method:'get',
          url:'/api/intelligence/resourcePackageList', 
          params: {
            name: this.inputName,
            type: this.selectType==undefined?'':this.selectType,
            startTime: this.dateList[0]==undefined?'':moment(this.dateList[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
            endTime: this.dateList[1]==undefined?'':moment(this.dateList[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.ifShowLoadingSource = false
          this.packageSourceData = response.data.data.records
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    resetSource() {
      this.inputName = ''
      this.dateList = []
      this.selectType = undefined
      this.queryDataSource()
    },
    goToMiddleCenter() {
      let host = window.location.host
      this.axios(
          {
              method:'get',
              url:'/api/intelligence/superLoginUrl', 
              params: {
                  hostName: host
              }
          }
      )
      .then(response=> {
          if(response.data.code == 0){
              let url = response.data.data.superLoginUrl
              window.location.href = url + "&purchase=true"
          }else{
              this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error);
      })
    }
  },
  mounted: function() {
    this.sessionData('set','leftNavItem','sourcePackage');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .dialogues{
    padding: 24px 24px 50px;
    .left{
      float: left;
    }
    .right{
      float: right;
    }
    height: 100%;
    background: #eee;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: 50px;
    .condition{
      // border-radius: 4px;
      width: 100%;
      max-height: 337px;
      background: #fff;
      padding: 24px 40px;
      .title{
        // padding-bottom: 8px;
        span{
          font-size: 18px;
          color: #333;
        }
        i{
          cursor: pointer;
          // display: none;
        }
        i:hover{
          color: rgba(34, 215, 187, 1);
        }
      }
      .date{
        span.title{
          color: rgba(80, 80, 80, 1);
          font-size: 14px;
          display: inline-block;
        }
      }
      .info{
        span{
          margin-right: 8px;
        }
        .phone{
          width: 40%;
        }
      }
      .pro-tag{
        span{
          margin-right: 8px;
        }
      }
      .btn-group{
        button:nth-child(1):hover{
          color: rgba(34, 215, 187, 1) !important;
        }
        button span{
          margin-right: 0px !important;
        }
      }
    }
    .condition:hover{
      i{
        display: inline-block;
      }
    }
    .result-view{
      margin-top: 16px;
      // border-radius: 4px;
      margin-bottom:24px;
      flex: 1;
      background: #fff;
      padding: 22px 40px;
      .operation{
        font-size: 14px;
        color: rgba(204, 204, 204, 1);
      }
      .table-content{
        padding-top: 15px;
        position: relative;
        th{
          height: 48px;
          line-height: 48px;
          background: #F0F0F0;
          padding-top:0px;
          padding-bottom:0px;
        }
        td{
          padding-top: 8px;
          padding-bottom: 8px;
        }
      }
    }
  }
  .output-detail{
    .ant-table-thead > tr > th{
      height: 48px;
      line-height: 48px;
      background: #F0F0F0 !important;
      padding-top:0px;
      padding-bottom:0px;
    }
    td{
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
</style>
